// Product Addon

function toggleCart(variantId, button) {
  if (button.textContent === "+ Add") {
    addToCart(variantId, button);
  } else {
    removeFromCart(variantId, button);
  }
}

function addToCart(variantId, button) {
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "Added";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function removeFromCart(variantId, button) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === 422) {
        console.error("Unprocessable Content", data);
      } else {
        button.textContent = "+ Add";
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Footer Country Selector

document.addEventListener("DOMContentLoaded", function () {
  var usFlagLink = document.getElementById("flag");
  if (usFlagLink) {
    usFlagLink.addEventListener("click", function (event) {
      event.preventDefault();
    });
  }
});

// Infinite Addons quantity matcher
$(document).ready(function () {
  $('input[name="quantity"]').on("change", function () {
    var quantity = $(this).val(); // Get the product quantity

    $('select[name="addon_field"], input[name="addon_field"]').each(
      function () {
        var addonField = $(this);
        addonField.attr("data-quantity", quantity);
      }
    );
  });
});

// Fix Slider Buttons
$(document).ready(function () {
  // Fix featured collection slider buttons
  $(document).on(
    "click",
    ".featured-collection-controls .prev, .featured-collection-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest(
        '[data-section-type="featured-collection"]'
      );
      var $slider = $("[data-carousel-enabled]", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  // Fix slideshow buttons
  $(document).on(
    "click",
    ".full-width-slideshow-controls .prev, .full-width-slideshow-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="slideshow"]');
      var $slider = $(".js-slideshow-section", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );

  // Fix gallery buttons
  $(document).on(
    "click",
    ".gallery-controls .prev, .gallery-controls .next",
    function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest('[data-section-type="gallery"]');
      var $slider = $(".js-gallery-slider", $container);

      if ($slider.length && $slider.hasClass("slick-initialized")) {
        if ($button.hasClass("prev")) {
          $slider.slick("slickPrev");
        } else {
          $slider.slick("slickNext");
        }
      }
    }
  );
});

// Back in stock (mailto button) — COPY/PASTE THIS WHOLE BLOCK INTO custom.js
// IMPORTANT: Your Liquid must include:
// 1) #sold-out-variants-json
// 2) #product-variants-json
// 3) #product-data-json
// 4) #back-in-stock-wrapper
// 5) <a id="back-in-stock-email-link" href="mailto:...">

(function () {
  var soldOutEl = document.getElementById('sold-out-variants-json');
  var variantsEl = document.getElementById('product-variants-json');
  var productEl = document.getElementById('product-data-json');
  var wrapper = document.getElementById('back-in-stock-wrapper');
  var emailLink = document.getElementById('back-in-stock-email-link');

  // If this product template doesn't include the back-in-stock block, do nothing
  if (!soldOutEl || !variantsEl || !productEl || !wrapper || !emailLink) return;

  var soldOutVariants = [];
  var productVariants = [];
  var productData = {};

  try { soldOutVariants = JSON.parse(soldOutEl.textContent || '[]'); } catch (e) { soldOutVariants = []; }
  try { productVariants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { productVariants = []; }
  try { productData = JSON.parse(productEl.textContent || '{}'); } catch (e) { productData = {}; }

  // Your theme updates this hidden input when variant changes
  var variantInput = document.querySelector('input[name="id"]');
  if (!variantInput) return;

  // Your theme uses these selectors for variant options (keep it consistent)
  var variantDropdowns = document.querySelectorAll('.option-selector[data-single-option-selector]');

  function getCurrentVariantObject() {
    var variantId = String(variantInput.value || '');
    for (var i = 0; i < productVariants.length; i++) {
      if (String(productVariants[i].id) === variantId) return productVariants[i];
    }
    return null;
  }

  function buildMailtoHref(variant) {
    // Keep the "To:" from Liquid (mailto:{{ shop.email }}) and only update subject/body
    var baseMailto = (emailLink.getAttribute('href') || '').split('?')[0];
    if (!baseMailto.toLowerCase().startsWith('mailto:')) return;

    var productTitle = (productData && productData.title) ? productData.title : (document.title || '');
    var variantTitle =
      (variant && variant.title && String(variant.title).toLowerCase() !== 'default title')
        ? String(variant.title)
        : '';

    var variantId = (variant && variant.id) ? String(variant.id) : String(variantInput.value || '');
    var sku = (variant && variant.sku) ? String(variant.sku) : '';

    var productUrl =
      window.location.origin + window.location.pathname +
      (variantId ? ('?variant=' + encodeURIComponent(variantId)) : '');

    var subject = variantTitle
      ? ('Back in stock request – ' + productTitle + ' – ' + variantTitle)
      : ('Back in stock request – ' + productTitle);

    // KEY FIXES:
    // - We keep blank lines for readability (we DO NOT remove '')
    // - We use CRLF (\r\n) to render nicely in Outlook/Windows email clients
    // - We never encode the array directly (prevents commas)
    var bodyLines = [
      'Hi The Balcony Garden team,',
      '',
      'Could you please notify me when the item below is back in stock?',
      '',
      'Product: ' + productTitle,
      variantTitle ? ('Variant: ' + variantTitle) : null,
      sku ? ('SKU: ' + sku) : null,
      variantId ? ('Variant ID: ' + variantId) : null,
      'Link: ' + productUrl,
      '',
      'Thanks!'
    ].filter(function (line) { return line !== null && line !== undefined; });

    var body = bodyLines.join('\r\n');

    var href =
      baseMailto +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);

    emailLink.setAttribute('href', href);
  }

  function updateBackInStockUI() {
    var currentVariant = getCurrentVariantObject();
    if (!currentVariant) return;

    var variantIdNum = Number(variantInput.value);
    var isSoldOut = soldOutVariants.indexOf(variantIdNum) !== -1;

    if (isSoldOut) {
      wrapper.style.display = 'block';
      buildMailtoHref(currentVariant);
    } else {
      wrapper.style.display = 'none';
    }
  }

  // Update when customer changes options
  if (variantDropdowns && variantDropdowns.length) {
    variantDropdowns.forEach(function (dropdown) {
      dropdown.addEventListener('change', updateBackInStockUI);
      dropdown.addEventListener('click', updateBackInStockUI);
    });
  }

  // Extra reliability: listen to theme’s global variant update event (if jQuery exists)
  if (window.jQuery) {
    window.jQuery(window).on('cc-variant-updated.backInStockMailto', function () {
      updateBackInStockUI();
    });
  }

  // Initial run
  updateBackInStockUI();
})();